import { render, staticRenderFns } from "./PopupToggle.vue?vue&type=template&id=72b70ed6&"
import script from "./PopupToggle.vue?vue&type=script&lang=ts&"
export * from "./PopupToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports